var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1000008174(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 53,
    viewBox: "0 0 189 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.5037 23.4595H75.4114V17.0239H69.3745V23.4595H66.2822V8.44139H69.3745V14.539H75.4114V8.44139H78.5037V23.4595Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9842 20.3643H86.5574L85.5248 23.4593H82.237L87.8276 8.44122H90.6955L96.3177 23.462H93.0273L91.9842 20.3643ZM87.3945 17.8582H91.1497L89.2615 12.236L87.3945 17.8582Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.931 20.9744H109.501V23.4593H99.8357V8.44122H102.931V20.9744Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.421 17.3222H116.479V23.4593H113.384V8.44122H123.155V10.9473H116.479V14.8266H122.421V17.3222Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.778 18.1688V23.4503H131.683V8.44278H137.551C138.577 8.42082 139.594 8.63211 140.527 9.06072C141.344 9.43912 142.032 10.0511 142.502 10.8195C142.969 11.6028 143.209 12.5008 143.194 13.4127C143.194 14.8845 142.69 16.0447 141.683 16.8933C140.676 17.7418 139.282 18.1661 137.5 18.1661L134.778 18.1688ZM134.778 15.6627H137.551C138.369 15.6627 138.993 15.4699 139.423 15.0843C139.643 14.8723 139.815 14.6149 139.927 14.3299C140.038 14.0449 140.086 13.7392 140.067 13.4338C140.079 13.1069 140.027 12.7808 139.912 12.4744C139.797 12.168 139.623 11.8874 139.399 11.6487C139.164 11.4152 138.883 11.2325 138.574 11.1117C138.265 10.9909 137.935 10.9346 137.603 10.9462H134.778V15.6627Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.067 20.3643H148.643L147.611 23.4593H144.318L149.908 8.44122H152.776L158.398 23.462H155.108L154.067 20.3643ZM149.478 17.8582H153.233L151.345 12.236L149.478 17.8582Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.698 19.5202C169.712 19.2624 169.664 19.0049 169.556 18.7701C169.448 18.5354 169.285 18.3305 169.08 18.1734C168.666 17.8636 167.926 17.5326 166.859 17.1805C165.981 16.913 165.129 16.5693 164.311 16.1532C162.605 15.2325 161.752 13.9913 161.752 12.4297C161.742 11.6512 161.982 10.8901 162.438 10.259C162.943 9.58811 163.625 9.07212 164.408 8.76959C165.325 8.40345 166.305 8.22389 167.292 8.24144C168.279 8.22398 169.258 8.42319 170.16 8.82505C170.955 9.1766 171.632 9.74729 172.114 10.4703C172.581 11.1877 172.824 12.028 172.811 12.8839H169.708C169.725 12.5854 169.676 12.2868 169.563 12.0096C169.451 11.7325 169.279 11.4836 169.059 11.281C168.542 10.8714 167.892 10.6673 167.234 10.7079C166.609 10.6704 165.989 10.8393 165.47 11.1885C165.27 11.3324 165.109 11.5228 164.999 11.7432C164.89 11.9636 164.835 12.2074 164.841 12.4535C164.847 12.7044 164.919 12.9495 165.048 13.1648C165.177 13.38 165.36 13.5581 165.578 13.6814C166.254 14.0928 166.985 14.4058 167.749 14.611C169.509 15.1392 170.792 15.7958 171.597 16.581C171.99 16.9585 172.301 17.4139 172.509 17.9182C172.716 18.4224 172.817 18.9644 172.803 19.5096C172.827 20.1013 172.704 20.6895 172.447 21.2228C172.189 21.756 171.805 22.2178 171.327 22.5677C170.343 23.3071 169.023 23.6768 167.366 23.6768C166.277 23.6933 165.196 23.4773 164.197 23.043C163.324 22.681 162.571 22.0784 162.026 21.3054C161.522 20.5488 161.261 19.6558 161.279 18.7465H164.385C164.385 20.4049 165.375 21.2332 167.356 21.2314C167.962 21.2667 168.565 21.1096 169.077 20.7825C169.279 20.6414 169.441 20.4517 169.55 20.231C169.658 20.0103 169.709 19.7658 169.698 19.5202Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.319 10.9473H183.718V23.4593H180.623V10.9473H176.084V8.44122H188.319V10.9473Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4957 45.2327H75.4007L69.3771 35.3509V45.2327H66.2821V30.2145H69.3771L75.4113 40.1175V30.2145H78.4957V45.2327Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6004 45.2327H83.5081V30.2145H86.6031L86.6004 45.2327Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M103.796 45.2327H100.701L94.6776 35.3509V45.2327H91.5826V30.2145H94.6776L100.712 40.1175V30.2145H103.796V45.2327Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.647 38.7231H111.705V42.7477H118.679V45.2327H108.61V30.2145H118.645V32.7206H111.705V36.3121H117.647V38.7231Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1503_331)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.016 44.9747V52.1309H0.420525V28.5386H7.57472V44.9747H24.016Z",
    fill: "#CED4DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4893 0.0622559V52.1302H28.8938V44.974H45.3351V7.23291H7.57472V23.6691H4.48541V23.6546H0.420525V0.0622559H52.4893Z",
    fill: "#6C757D",
    stroke: "white",
    strokeWidth: 0.343344,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1503_331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52.1883,
    height: 52.1883,
    fill: "white",
    transform: "translate(0.360352)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1000008174);
export default __webpack_public_path__ + "static/media/Group 1000008174.9d76948e71b9190ebb4cf49ea3671b29.svg";
export { ForwardRef as ReactComponent };